<template>
  <div class="no-disturb">
    <disturbTopbar @btnClick="btnClick" @selectGrade="selectGrade" :gradeSelectList="gradeSelectList"
      :gradePlaceholder="gradePlaceholder" @selectClass="selectClass" :classSelectList="classSelectList" />
    <div class="student-info-table-container" v-bitmap="getListResult">
      <disturbStudent :showList="studentList" @multipleDelete="multipleDelete" />
    </div>
    <div class="student-info-pagination-catainer">
      <div class="pagination" v-if="parseInt(total)">
        <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
      </div>
    </div>
    <disturbTime :timeShow.sync="timeShow" v-show="timeShow" @submit="submit" ref="disturbTime"
      :selectStuedntList="deleteList" :deviceDetail="deviceDetail" />
  </div>
</template>

<script>
import disturbTopbar from "./components/disturb-topbar/disturb-topbar.vue";
import disturbStudent from "./components/disturb-student/disturb-student.vue";
import disturbTime from "./components/disturb-time-new/disturb-time.vue";
import pagination from "@/components/pagination/pagination";

export default {
  name: "",
  data() {
    return {
      getListResult: "nullData",
      studentList: [], // 班级学生信息
      timeShow: false, // 选择时间弹出框是否显示
      showList: [], // 当前显示学生
      setList: [], // 已设置免打扰的学生
      noSetList: [], // 未设置免打扰的学生
      newStudentList: [], // 选择的学生列表
      gradeId: "",
      classId: "",
      gradeSelectList: [],
      gradePlaceholder: "请选择年级",
      classSelectList: [],
      deleteList: [],
      deviceDetail: {},
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
    };
  },
  components: {
    disturbTopbar,
    disturbStudent,
    disturbTime,
    pagination
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageInfo.pageSize = val;
      this.getStudentInfo();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getStudentInfo();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getStudentInfo();
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log("班级列表==>", res);
          this.gradeSelectList = res.data;
          // 默认选中第一项
          // this.gradeId = res.data[0].gradeId;
          // this.gradePlaceholder = res.data[0].gradeName;
          this.classSelectList = res.data.find(
            (item) => item.gradeId == res.data[0].gradeId
          ).schoolClassList;
          this.getStudentInfo();
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    selectClass(e) {
      this.classId = e;
      this.getStudentInfo();
    },
    // 切换年级
    selectGrade(e) {
      // console.log(e);
      this.gradeId = e;
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.gradePlaceholder = "请选择年级";
        this.classSelectList = [];
      }
      this.getStudentInfo();
    },
    // 获取学生信息
    getStudentInfo() {
      // this.getListResult = "loading";
      this.studentList = [];
      this.get(this.$url.getStudentInfo, {
        gradeId: this.gradeId, //年级ID，非必填
        classId: this.classId,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
      })
        .then((res) => {
          // console.log("学生信息==>", res);
          if (res.code == 200) {
            this.studentList = res.rows;
            this.total = res.total;
            this.newStudentList = this.studentList.filter(
              (item) => item.deviceId
            );
            // console.log("绑定设备了的学生==>",this.newStudentList);
            this.total > 0
              ? (this.getListResult = "success")
              : (this.getListResult = "nullData");
          } else {
            this.$message.error("获取学生数据失败");
            return (this.getListResult = "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取学生数据失败，请稍后再试");
          return (this.getListResult = "error");
        });
    },
    // 顶部按钮
    btnClick(type) {
      // console.log("this.deleteList==>", this.deleteList);
      // if (this.newStudentList.length) {
      //  let editList = this.newStudentList.filter((item) => item.days);
      // } else {
      //   if (type == "edit") {
      //     this.$message.warning("暂无已绑定设备的学生");
      //   } else if (type == "clear") {
      //     this.$message.warning("暂无已设置免打扰的学生");
      //   }
      // }

      if (!this.deleteList.length)
        return this.$message.warning("请先选择需要编辑的学生！");

      if (
        this.deleteList.includes(undefined) ||
        this.deleteList.includes(null)
      ) {
        // 数组中包含undefined元素
        this.$message.warning("选中学生的中包含未绑定设备的学生！");
        // 进行相应的操作
      } else {
        // 数组中不包含undefined元素
        // 进行其他操作
        if (this.deleteList.length == 1) {
          this.getDeviceDetail(this.deleteList[0]);
        }
        if (type == "edit") {
          // 编辑
          this.timeShow = true;
        } else if (type == "clear") {
          // 清空
          this.clearClick(this.deleteList);
        }
      }
    },
    // 获取单个设备免打扰详情 - 给单个设备设置免打扰时调用
    getDeviceDetail(deviceId) {
      this.get(this.$url.findDisable + "?deviceId=" + deviceId).then((res) => {
        // console.log("获取单个设备免打扰详情==>", res);
        this.deviceDetail = res.data;
        setTimeout(() => {
          this.$refs.disturbTime.getSingleDeviceImmunity();
        }, 300);
      });
    },
    // 清空免打扰
    clearClick(list) {
      // let qTimeList = [];
      // list.forEach((item) => {
      //   qTimeList.push({
      //     deviceId: item.deviceId, // '71041605673'
      //   });
      // });
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要清空免打扰的学生");
      }
      this.$confirm("是否清空选中学生的免打扰设置?", "清空免打扰", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // console.log("清空qTimeList=>", qTimeList);
          // 调用接口
          // this.setDisturb(qTimeList, "clear");
          let deleteList = this.deleteList.map((item) => {
            return (item = {
              deviceId: item,
            });
          });
          this.clearDisturb(deleteList);
        })
        .catch(() => { });
    },
    // 点击保存按钮
    submit(noDisturb) {
      // console.log(student)
      // console.log(noDisturb);
      // let qTimeList = [];
      // let { times, days } = noDisturb;
      // // 选择的学生设置免打扰
      // this.newStudentList.forEach((item) => {
      //   // 判断是否有设备
      //   if (item.deviceId) {
      //     qTimeList.push({
      //       deviceId: item.deviceId, // '71041605673'
      //       timeQuannums: times,
      //       days,
      //     });
      //   }
      // });
      // 调用接口
      this.setDisturb(noDisturb, "edit");
    },
    // 清空免打扰
    clearDisturb(qTimeList) {
      this.post(this.$url.clearDisturb, {
        qTimeList,
      })
        .then((res) => {
          console.log("免打扰清除结果==>", res);
          if (res.code == 200) {
            this.$message.success("免打扰清除成功");
            // 重新获取数据
            this.getStudentInfo();
          } else {
            this.$message.error("免打扰清除失败");
          }
        })
        .catch((err) => {
          console.log("免打扰清除报错==>", err);
        });
    },
    // 调用接口设置免打扰
    setDisturb(qTimeList, type) {
      this.post(this.$url.setDisturb, qTimeList)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message.success("免打扰设置成功");
            // 重新获取数据
            this.getStudentInfo();
            if (type == "edit") {
              // 关闭dialog
              this.$refs.disturbTime.dialogClose();
            }
          } else {
            this.$message.error("免打扰设置失败");
          }
        })
        .catch((err) => {
          // console.log(err);
          this.$message.error("免打扰设置失败，请稍后再试");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./no-disturb.scss";
</style>
